export default "__VITE_ASSET__Bg0P_$$s__"